import { useState, useEffect } from 'react';

import { api } from '@/services';
import { getErrorDetails } from '@/utils';
import { PLATFORM_CAPTIONS } from '@/constants';

const useProfilePlaylists = ({
  source,
  target,
  onUnauthorized,
  sourceProfileUrl,
}) => {
  const [error, setError] = useState(null);
  const [playlists, setPlaylists] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const resetState = () => {
    setError(null);
    setPlaylists(null);
    setIsLoading(false);
  };

  useEffect(() => {
    resetState();
  }, [source, target, sourceProfileUrl]);

  const caption = PLATFORM_CAPTIONS[source];

  const getPlaylists = async () => {
    setError(null);
    setPlaylists(null);
    setIsLoading(true);

    try {
      setPlaylists(await api.getProfilePlaylists(source, sourceProfileUrl));
    } catch (error) {
      setPlaylists(null);

      const { is401, is500, message } = getErrorDetails(error);

      if (is401) {
        onUnauthorized();
      } else if (is500) {
        setError(`Failed to get ${caption}  playlists. Please try again.`);
      } else {
        setError(message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const clearPlaylists = () => resetState();

  return { error, playlists, isLoading, getPlaylists, clearPlaylists };
};

export default useProfilePlaylists;
